<template>
  <div :id="id" uk-modal>
    <div class="uk-modal-dialog">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h2 class="uk-modal-title">Error</h2>
      </div>
      <div class="uk-modal-body">{{ message }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ErrorModal',
  components: {
  },
  data() {
    return {
    }
  },
  props: ['id', 'message']
}
</script>

<style scoped lang="less">
@import "../../assets/less/theme.less";

</style>
